export default __webpack_public_path__ + "static/media/movipack_feature3hover.c7842bbd.svg";